export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    create: 'New',
    new: 'New',
    search: 'Search',
    searching: 'Searching...',
    saving: 'Saving...',
    deleting: 'Deleting...',
    loading: 'Loading...',
    clearFilters: 'Clear Filters',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    noResults: 'No records found.',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMsg: 'Are you sure you want to delete',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    validation: 'Validation',
    required: 'Required field',
    exportCsv: 'Export CSV',
    exportPdf: 'Export PDF',
    exportSuccess: 'Export completed!',
    exportError: 'Export error',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    id: 'Code',
    name: 'Name',
    description: 'Description',
    date: 'Date',
    value: 'Value',
    total: 'Total',
    details: 'Details',
    information: 'Information',
    confirm: 'Confirm',
    back: 'Back',
    refresh: 'Refresh',
    select: 'Select',
    open: 'Open',
    closed: 'Closed',
    generating: 'Generating...',
    calculating: 'Calculating...',
    processing: 'Processing...',
    sending: 'Sending...',
  },

  validation: {
    required: 'Required field',
    email: 'Invalid email',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
    positive: 'Value must be positive',
    invalidCpf: 'Invalid CPF',
    invalidCnpj: 'Invalid CNPJ',
    passwordsDontMatch: 'Passwords do not match',
    allFieldsRequired: 'All fields are required',
  },

  status: {
    PENDENTE: 'Pending',
    CONCLUIDA: 'Completed',
    CANCELADA: 'Cancelled',
    PAGO: 'Paid',
    PAGA: 'Paid',
    VENCIDO: 'Overdue',
    VENCIDA: 'Overdue',
    ABERTO: 'Open',
    FECHADO: 'Closed',
    EM_TRANSITO: 'In Transit',
    EM_ANDAMENTO: 'In Progress',
    ATIVO: 'Active',
    INATIVO: 'Inactive',
    PROCESSANDO: 'Processing',
    ERRO: 'Error',
    CONVERTIDO: 'Converted',
    EXPIRADO: 'Expired',
    APROVADO: 'Approved',
    REJEITADO: 'Rejected',
    NORMAL: 'Normal',
    ALERTA: 'Alert',
    AGENDADO: 'Scheduled',
    AGENDADA: 'Scheduled',
    CONCLUIDO: 'Completed',
    REALIZADA: 'Completed',
    CONFIRMADO: 'Confirmed',
    CANCELADO: 'Cancelled',
    LIVRE: 'Available',
    OCUPADA: 'Occupied',
    RESERVADA: 'Reserved',
    ABERTA: 'Open',
    AGUARDANDO_PECAS: 'Awaiting Parts',
    ENTREGUE: 'Delivered',
  },

  paymentMethod: {
    DINHEIRO: 'Cash',
    CARTAO_CREDITO: 'Credit Card',
    CARTAO_DEBITO: 'Debit Card',
    CHEQUE: 'Check',
    PIX: 'PIX',
    BOLETO: 'Bank Slip',
  },

  nav: {
    dashboard: 'Dashboard',
    caixa: 'Cash Register',
    vendas: 'Sales',
    orcamentos: 'Quotes',
    clientes: 'Customers',
    produtos: 'Products',
    categorias: 'Categories',
    estoque: 'Inventory',
    inventario: 'Stock Count',
    fornecedores: 'Suppliers',
    trocas: 'Returns',
    promocoes: 'Promotions',
    contasReceber: 'Accounts Receivable',
    contasPagar: 'Accounts Payable',
    entregas: 'Deliveries',
    etiquetas: 'Labels',
    relatorios: 'Reports',
    importacao: 'Import',
    notificacoes: 'Notifications',
    usuarios: 'Users',
    perfis: 'Profiles',
    comissoes: 'Commissions',
    configuracoes: 'Settings',
    auditoria: 'Audit',
    loja: 'Store',
    administracao: 'Administration',
    meuPerfil: 'My Profile',
    permissoes: 'Permissions',
    banhoTosa: 'Grooming',
    racoes: 'Pet Food & Accessories',
    cardapio: 'Menu',
    mesas: 'Tables',
    prontuarios: 'Records',
    consultas: 'Consultations',
    fidelidade: 'Loyalty',
    servicos: 'Services',
    profissionais: 'Professionals',
    agenda: 'Schedule',
    funcionarios: 'Employees',
    agendamentos: 'Appointments',
    ordensServico: 'Service Orders',
  },

  login: {
    welcome: 'Welcome to SisGel',
    subtitle: 'Management System for your store',
    formTitle: 'System Access',
    formSubtitle: 'Enter your credentials to continue',
    username: 'Username',
    password: 'Password',
    enter: 'Sign In',
    entering: 'Signing in...',
    usernameRequired: 'Username is required',
    usernameMinLength: 'Username must be at least 3 characters',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 4 characters',
    loginSuccess: 'Login successful!',
    loginError: 'Login error',
    help: 'If you have problems, contact the administrator',
    footer: 'SisGel - Store Management System',
  },

  meuPerfil: {
    title: 'My Profile',
    userInfo: 'User Information',
    editProfile: 'Edit Profile',
    changePassword: 'Change Password',
    nome: 'Name',
    email: 'Email',
    perfil: 'Profile',
    loja: 'Store',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    saveProfile: 'Save Profile',
    nameEmailRequired: 'Name and email are required',
    passwordFieldsRequired: 'All password fields are required',
    profileUpdated: 'Profile updated successfully!',
    passwordChanged: 'Password changed successfully!',
    profileUpdateError: 'Error updating profile',
    passwordChangeError: 'Error changing password',
    nomePlaceholder: 'Your name',
    emailPlaceholder: 'Your email',
    nomeLoja: 'Store Name',
    nomelLojaPlaceholder: 'Your store name',
    changingPassword: 'Changing...',
  },

  fornecedor: {
    title: 'Supplier Management',
    new: 'New Supplier',
    edit: 'Edit Supplier',
    details: 'Supplier Details',
    razaoSocial: 'Company Name',
    nomeFantasia: 'Trade Name',
    cnpj: 'CNPJ',
    telefone: 'Phone',
    email: 'Email',
    endereco: 'Address',
    contato: 'Contact',
    created: 'Supplier created successfully!',
    updated: 'Supplier updated successfully!',
    deleted: 'Supplier deleted successfully!',
    createError: 'Error creating supplier',
    updateError: 'Error updating supplier',
    deleteError: 'Error deleting supplier',
    notFound: 'No suppliers found.',
    requiredRazaoSocial: 'Company name is required',
  },

  cliente: {
    title: 'Customer Management',
    new: 'New Customer',
    edit: 'Edit Customer',
    details: 'Customer Details',
    nome: 'Name',
    telefone: 'Phone',
    endereco: 'Address',
    dataCriacao: 'Created At',
    created: 'Customer created successfully!',
    updated: 'Customer updated successfully!',
    deleted: 'Customer deleted successfully!',
    notFound: 'No customers found.',
    nameRequired: 'Name is required',
    informacoes: 'Customer Information',
    nomePlaceholder: 'Customer Name',
    nomeCompleto: 'Full customer name',
    enderecoCompleto: 'Full address',
  },

  produto: {
    title: 'Product Management',
    new: 'New Product',
    edit: 'Edit Product',
    details: 'Product Details',
    nome: 'Name',
    descricao: 'Description',
    codigoBarras: 'Barcode',
    precoVenda: 'Selling Price',
    precoCusto: 'Cost Price',
    unidadeMedida: 'Unit of Measure',
    categoria: 'Category',
    created: 'Product created successfully!',
    updated: 'Product updated successfully!',
    deleted: 'Product deleted successfully!',
    informacoes: 'Product Information',
    nomePlaceholder: 'Product Name',
    descricaoPlaceholder: 'Product Description',
    margemLucro: 'Profit Margin (%)',
    margem: 'Margin',
    valores: 'Prices',
    selecioneUnidade: 'Select a unit',
    selecioneCategoria: 'Select a category',
    calculationHint: 'Enter selling price to calculate margin, or margin to calculate selling price',
    produtoAtivo: 'Active Product',
    dataCadastro: 'Registration Date',
    activate: 'Activate',
    deactivate: 'Deactivate',
    notFound: 'No products found.',
  },

  categoria: {
    title: 'Category Management',
    new: 'New Category',
    edit: 'Edit Category',
    details: 'Category Details',
    nome: 'Name',
    descricao: 'Description',
    codigoInterno: 'Internal Code',
    informacoes: 'Category Information',
    nomePlaceholder: 'Category Name',
    codigoInternoPlaceholder: 'Internal code (optional)',
    descricaoPlaceholder: 'Enter a description for the category',
    categoriaAtiva: 'Active Category',
    categoriaInativa: 'Inactive Category',
    dataCriacao: 'Created At',
    activate: 'Activate',
    deactivate: 'Deactivate',
    created: 'Category created successfully!',
    updated: 'Category updated successfully!',
    deleted: 'Category deleted successfully!',
    notFound: 'No categories found.',
  },

  estoque: {
    title: 'Inventory Control',
    new: 'New Inventory',
    edit: 'Edit Inventory',
    details: 'Inventory Details',
    produto: 'Product',
    quantidade: 'Quantity',
    quantidadeMinima: 'Minimum Quantity',
    localizacao: 'Location',
    ultimaEntrada: 'Last Entry',
    ultimaSaida: 'Last Exit',
    informacoes: 'Inventory Information',
    historico: 'History',
    todasLocalizacoes: 'All Locations',
    nomeProduto: 'Product Name',
    selecioneProduto: 'Select a product',
    selecioneLocalizacao: 'Select location',
    dataAtualizacao: 'Updated At',
    alerta: 'Alert',
    normal: 'Normal',
    created: 'Inventory created successfully!',
    updated: 'Inventory updated successfully!',
    deleted: 'Inventory deleted successfully!',
    notFound: 'No inventory found.',
  },

  venda: {
    title: 'Sales',
    dataHora: 'Date/Time',
    responsavel: 'Responsible',
    tipo: 'Type',
    totalBruto: 'Gross Total',
    desconto: 'Discount',
    totalLiquido: 'Net Total',
    notFound: 'No sales found.',
    allStatus: 'All Status',
    concluidas: 'Completed',
    pendentes: 'Pending',
    canceladas: 'Cancelled',
    allCaixas: 'All Registers',
    vendas: 'sale(s)',
    caixa: 'Register',
  },

  caixa: {
    title: 'Cash Register',
    statusCaixa: 'Register Status',
    saldoInicial: 'Opening Balance',
    totalVendido: 'Total Sold',
    saldoFinal: 'Closing Balance',
    vendasHoje: 'Sales Today',
    abrirCaixa: 'OPEN REGISTER',
    fecharCaixa: 'CLOSE REGISTER',
    novaVenda: 'NEW SALE',
    vendasDoCaixa: 'Register Sales',
    caixaNaoAberto: 'Register not open',
    carregandoVendas: 'Loading sales...',
    nenhumaVenda: 'No sales found',
    todas: 'All',
    apenasGerentesFecham: 'Only managers can close the register',
    detalhesVenda: 'Sale Details',
    informacoesVenda: 'Sale Information',
    data: 'Date',
    hora: 'Time',
    responsavel: 'Responsible',
    tipoVenda: 'Sale Type',
    cliente: 'Customer',
    naoInformado: 'Not informed',
    observacoes: 'Notes',
    nenhuma: 'None',
    itensVenda: 'Sale Items',
    produto: 'Product',
    qtd: 'Qty',
    precoUnit: 'Unit Price',
    nenhumItem: 'No items found for this sale',
    informacoesPagamento: 'Payment Information',
    formaPagamento: 'Payment Method',
    valorPago: 'Amount Paid',
    dataPagamento: 'Payment Date',
    numParcelas: 'Installments',
    pagamentoNaoEncontrado: 'Payment information not found',
    pagamento: 'Payment',
    parcelas: 'Installments',
    totalBruto: 'Gross Total',
    desconto: 'Discount',
    totalLiquido: 'Net Total',
    carregandoDetalhes: 'Loading details...',
    salvarConcluir: 'Save and Complete',
    concluirVenda: 'Complete Sale',
    cancelando: 'Cancelling...',
    cancelarVenda: 'Cancel Sale',
    entendi: 'Understood',
    fecharCaixaTitle: 'Close Register',
    resumoCaixa: 'Register Summary',
    operador: 'Operator',
    abertoEm: 'Opened at',
    fechamento: 'Closing',
    valorEmCaixa: 'Cash in register (count)',
    informeValorContado: 'Enter the counted cash amount',
    observacoesFechamento: 'Closing notes',
    observacoesFechamentoPlaceholder: 'Notes about the closing...',
    saldoEsperado: 'Expected Balance',
    valorContado: 'Counted Amount',
    diferenca: 'Difference',
    fechandoCaixa: 'Closing...',
    confirmarFechamento: 'Confirm Closing',
    iniciarVenda: 'Start Sale',
    clienteOpcional: 'Customer (optional)',
    semCliente: 'No customer (anonymous sale)',
    novoCliente: 'New Customer',
    nomeCliente: 'Customer name',
    telefone: 'Phone',
    telefonePlaceholder: '(00) 00000-0000',
    cadastrarCliente: 'Register and Select',
    totalDaVenda: 'Sale Total',
    quantidadeItens: 'Item Count',
    selecioneFormaPagamento: 'Select payment method',
    valorRecebido: 'Amount Received',
    troco: 'Change',
    valorInsuficiente: 'Insufficient amount! Missing',
    valorPorParcela: 'Amount per installment',
    parcelasGeradas: 'Generated Installments',
    salvarAberta: 'Save as Open',
    finalizarVenda: 'Finalize Sale',
    produtoNaoEncontrado: 'Product not found',
    quantidade: 'Quantity',
    precoUnitario: 'Unit Price',
    subtotal: 'Subtotal',
    removerItem: 'Remove item',
    parcela: 'Installment',
    vendaSemItens: 'Sale without items',
    adicioneItem: 'Add at least one item to complete the sale.',
    pagamentoObrigatorio: 'Payment required',
    selecionePagamento: 'Select a payment method to complete the sale.',
    valorInvalido: 'Invalid value',
    informeValorPago: 'Enter the paid amount to complete the sale.',
    confirmaConcluirVenda: 'Are you sure you want to complete this sale?',
    vendaConcluidaCancelar: 'This sale has already been completed. Are you sure you want to cancel?',
    confirmaCancelarVenda: 'Are you sure you want to cancel this sale?',
    vendaConcluidaSucesso: 'Sale completed successfully!',
    erroConcluirVenda: 'Error completing sale',
    vendaCanceladaSucesso: 'Sale cancelled successfully!',
    erroCancelarVenda: 'Error cancelling sale',
    caixaFechadoSucesso: 'Register closed successfully!',
    erroFecharCaixa: 'Error closing the register. Please try again.',
    diferencaCaixa: 'There is a difference of R$ {valor} in the register. Do you want to continue?',
    confirmaFechamento: 'Confirm closing the register?',
  },

  contaPagar: {
    title: 'Accounts Payable',
    new: 'New Payable',
    edit: 'Edit Payable',
    details: 'Payable Details',
    descricao: 'Description',
    fornecedor: 'Supplier',
    valor: 'Amount',
    valorPago: 'Amount Paid',
    dataEmissao: 'Issue Date',
    dataVencimento: 'Due Date',
    dataPagamento: 'Payment Date',
    categoria: 'Category',
    numeroDocumento: 'Document Number',
    numeroNotaFiscal: 'Invoice Number',
    observacao: 'Notes',
    registrarPagamento: 'Register Payment',
    total: 'Total',
    pendente: 'Pending',
    pago: 'Paid',
    vencido: 'Overdue',
    cancelado: 'Cancelled',
    created: 'Payable created successfully!',
    updated: 'Payable updated successfully!',
    deleted: 'Payable deleted successfully!',
    paymentRegistered: 'Payment registered successfully!',
    notFound: 'No payables found.',
    requiredFields: 'Fill in the required fields',
    requiredPayment: 'Enter amount and payment date',
    payBtn: 'Pay',
    allStatus: 'All Status',
    allCategories: 'All Categories',
    valorDaConta: 'Account Value',
    newConta: 'New Account',
    infoSection: 'Account Information',
    descPlaceholder: 'Account description',
    fornecedorPlaceholder: 'Select supplier',
    categoriaPlaceholder: 'Select a category',
    docPlaceholder: 'Document number',
    nfPlaceholder: 'Invoice number',
    obsPlaceholder: 'Additional notes',
    emissao: 'Issue',
    vencimento: 'Due Date',
    pagamento: 'Payment',
  },

  contasReceber: {
    title: 'Accounts Receivable',
    totalPendente: 'Total Pending',
    totalVencido: 'Total Overdue',
    aVencerHoje: 'Due Today',
    aVencerSemana: 'Due This Week',
    parcela: 'Installment',
    vencimento: 'Due Date',
    marcarPaga: 'Mark as Paid',
    carregandoResumo: 'Loading summary...',
    notFound: 'No installments found.',
    allStatus: 'All Status',
    paga: 'Paid',
    vencida: 'Overdue',
    dataInicio: 'Start Date',
    dataFim: 'End Date',
  },

  entrega: {
    title: 'Delivery Management',
    new: 'New Delivery',
    edit: 'Edit Delivery',
    details: 'Delivery Details',
    destinatario: 'Recipient',
    telefone: 'Phone',
    endereco: 'Address',
    logradouro: 'Street',
    numero: 'Number',
    complemento: 'Complement',
    bairro: 'District',
    cidade: 'City',
    uf: 'State',
    cep: 'Zip Code',
    transportadora: 'Carrier',
    codigoRastreio: 'Tracking Code',
    valorFrete: 'Freight Cost',
    pesoTotal: 'Total Weight',
    previsaoEntrega: 'Expected Delivery',
    observacao: 'Notes',
    alterarStatus: 'Change Status',
    novoStatus: 'New Status',
    venda: 'Sale',
    cliente: 'Customer',
    cidadeUf: 'City/State',
    previsao: 'Estimate',
    created: 'Delivery created successfully!',
    updated: 'Delivery updated successfully!',
    deleted: 'Delivery deleted successfully!',
    statusUpdated: 'Status updated successfully!',
    notFound: 'No deliveries found.',
    requiredFields: 'Fill required fields (Sale, Name, Street)',
    allStatus: 'All Status',
    emTransito: 'In Transit',
    vinculo: 'Link',
    selectVenda: 'Select sale...',
    selectCliente: 'Select customer',
    selectTransportadora: 'Select carrier',
    nomePlaceholder: 'Recipient name',
    logradouroPlaceholder: 'Street, Avenue...',
    complementoPlaceholder: 'Apt, Block...',
    transporte: 'Shipping',
  },

  orcamento: {
    title: 'Quotes',
    new: 'New Quote',
    edit: 'Edit Quote',
    details: 'Quote Details',
    cliente: 'Customer',
    dataCriacao: 'Created At',
    validade: 'Validity',
    total: 'Total',
    converter: 'Convert',
    created: 'Quote created successfully!',
    updated: 'Quote updated successfully!',
    deleted: 'Quote deleted successfully!',
    notFound: 'No quotes found.',
    allStatus: 'All Status',
    allClientes: 'All Customers',
    clienteId: 'Customer ID',
    info: 'Quote Information',
    dataValidade: 'Validity Date',
    observacao: 'Notes',
    itens: 'Items',
    addItem: 'Add Item',
    produto: 'Product',
    qtd: 'Qty',
    precoUnit: 'Unit Price',
    desconto: 'Discount',
    subtotal: 'Subtotal',
    totalEstimado: 'Estimated Total',
    totalLiquido: 'Net Total',
    totalBruto: 'Gross Total',
    noItem: 'No items.',
    selectCliente: 'Select customer...',
    selectProduto: 'Select product...',
  },

  troca: {
    title: 'Returns and Exchanges',
    new: 'New Return',
    details: 'Return Details',
    vendaOriginal: 'Original Sale',
    tipo: 'Type',
    motivo: 'Reason',
    valorTotal: 'Total Value',
    data: 'Date',
    created: 'Return created successfully!',
    deleted: 'Return deleted successfully!',
    notFound: 'No returns found.',
    allTipos: 'All Types',
    allMotivos: 'All Reasons',
    tipoTroca: 'Exchange',
    tipoDevolucao: 'Return',
    motivoDefeito: 'Defect',
    motivoInsatisfacao: 'Dissatisfaction',
    motivoErroVenda: 'Sale Error',
    motivoTamanho: 'Size',
    motivoOutro: 'Other',
    vendaId: 'Original Sale ID',
    info: 'Return Information',
    selectVenda: 'Select sale...',
    observacao: 'Notes',
    obsPlaceholder: 'Notes about the return',
    itens: 'Items',
    addItem: 'Add Item',
    produto: 'Product',
    quantidade: 'Quantity',
    valorUnit: 'Unit Price',
    subtotal: 'Subtotal',
    noItem: 'No items.',
  },

  promocao: {
    title: 'Promotions',
    new: 'New Promotion',
    edit: 'Edit Promotion',
    details: 'Promotion Details',
    nome: 'Name',
    tipoDesconto: 'Discount Type',
    valor: 'Value',
    dataInicio: 'Start Date',
    dataFim: 'End Date',
    ativa: 'Active',
    created: 'Promotion created successfully!',
    updated: 'Promotion updated successfully!',
    deleted: 'Promotion deleted successfully!',
    notFound: 'No promotions found.',
    todas: 'All',
    ativas: 'Active',
    inativas: 'Inactive',
    todosTipos: 'All Types',
    porcentagem: 'Percentage',
    valorFixo: 'Fixed Value',
    informacoes: 'Promotion Information',
    nomePlaceholder: 'Promotion name',
    tipoPromocao: 'Promotion Type',
    diaSemana: 'Day of the Week',
    horaInicio: 'Start Time',
    horaFim: 'End Time',
    comboProdutosInfo: 'Combo products are managed through the product links below.',
    leveQuantidade: 'Take (quantity)',
    pagueQuantidade: 'Pay (quantity)',
    precoClienteCadastrado: 'Registered Customer Price (R$)',
    precoClienteNaoCadastrado: 'Non-Registered Customer Price (R$)',
    valorDesconto: 'Discount Value',
    valorDescontoPlaceholder: 'Discount value',
    descricaoPlaceholder: 'Promotion description',
    vinculos: 'Links',
    produtoIds: 'Products',
    categoriaIds: 'Categories',
    selecioneProdutos: 'Select products...',
    selecioneCategorias: 'Select categories...',
    salvarPromocao: 'Save Promotion',
    dataCriacao: 'Created At',
    produtos: 'Products',
    categorias: 'Categories',
    nenhumProdutoVinculado: 'No linked products.',
    nenhumaCategoriaVinculada: 'No linked categories.',
    nomeeTipoObrigatorios: 'Name and Discount Type are required',
  },

  inventario: {
    title: 'Stock Counts',
    new: 'New Stock Count',
    edit: 'Edit Stock Count',
    details: 'Stock Count Details',
    dataCriacao: 'Created At',
    dataConclusao: 'Completed At',
    totalItens: 'Total Items',
    conferidos: 'Checked',
    divergentes: 'Divergent',
    concluir: 'Complete',
    observacao: 'Notes',
    obsPlaceholder: 'Stock count notes',
    conferencia: 'Checking',
    salvarContagens: 'Save Counts',
    confirmConclusao: 'Confirm Completion',
    confirmConclusaoMsg: 'Are you sure you want to complete the stock count',
    concluindo: 'Completing...',
    created: 'Stock count created successfully!',
    updated: 'Stock count updated successfully!',
    deleted: 'Stock count deleted successfully!',
    notFound: 'No stock counts found.',
  },

  importacao: {
    title: 'XML Import',
    importar: 'Import XML',
    arquivoUnico: 'Single File',
    loteArquivos: 'Batch Files',
    selecioneArquivo: 'Select an XML file',
    selecioneMultiplos: 'Select multiple XML files',
    enviarXml: 'Upload XML',
    enviarLote: 'Upload Batch',
    usuario: 'User',
    totalRegistros: 'Total Records',
    registrosSucesso: 'Successful Records',
    notFound: 'No imports found.',
  },

  relatorio: {
    title: 'Reports',
    gerar: 'Generate Report',
    tipo: 'Type',
    dataGeracao: 'Generated At',
    parametros: 'Report Parameters',
    dados: 'Report Data',
    dataInicio: 'Start Date',
    dataFim: 'End Date',
    pdf: 'PDF',
    notFound: 'No reports found.',
    tipoVendas: 'SALES',
    tipoProdutos: 'PRODUCTS',
    tipoEstoque: 'INVENTORY',
    tipoClientes: 'CUSTOMERS',
    tipoFinanceiro: 'FINANCIAL',
    tipoCaixa: 'REGISTER',
  },

  etiqueta: {
    title: 'Price Labels',
    layout: 'Label Layout',
    buscarProduto: 'Search Product',
    nomeProduto: 'Product name',
    produtosSelecionados: 'Selected Products',
    preco: 'Price',
    qtdEtiquetas: 'Label Qty',
    nenhumSelecionado: 'No products selected. Search and add products above.',
    gerarPdf: 'Generate PDF',
  },

  notificacao: {
    title: 'Notifications',
    marcarTodasLidas: 'Mark All as Read',
    nova: 'New',
    notFound: 'No notifications found.',
  },

  usuario: {
    title: 'User Management',
    new: 'New User',
    edit: 'Edit User',
    details: 'User Details',
    nome: 'Name',
    email: 'Email',
    senha: 'Password',
    perfil: 'Profile',
    loja: 'Store',
    informacoes: 'User Information',
    nomePlaceholder: 'User Name',
    selecionePerfil: 'Select a profile',
    manterPerfil: 'Keep current profile',
    ativo: 'Active User',
    created: 'User created successfully!',
    updated: 'User updated successfully!',
    deleted: 'User deleted successfully!',
    notFound: 'No users found.',
  },

  perfil: {
    title: 'Profile Management',
    new: 'New Profile',
    edit: 'Edit Profile',
    details: 'Profile Details',
    nome: 'Name',
    descricao: 'Description',
    nivelAcesso: 'Access Level',
    informacoes: 'Profile Information',
    nomePlaceholder: 'Profile Name',
    descricaoPlaceholder: 'Profile description',
    activate: 'Activate',
    deactivate: 'Deactivate',
    created: 'Profile created successfully!',
    updated: 'Profile updated successfully!',
    deleted: 'Profile deleted successfully!',
    notFound: 'No profiles found.',
  },

  configuracao: {
    title: 'System Settings',
    new: 'New Setting',
    edit: 'Edit Setting',
    chave: 'Key',
    valor: 'Value',
    descricao: 'Description',
    chavePlaceholder: 'Setting key',
    activate: 'Activate',
    deactivate: 'Deactivate',
    created: 'Setting created successfully!',
    updated: 'Setting updated successfully!',
    deleted: 'Setting deleted successfully!',
    notFound: 'No settings found.',
  },

  auditoria: {
    title: 'Audit Log',
    acao: 'Action',
    entidade: 'Entity',
    idEntidade: 'Entity ID',
    usuario: 'User',
    ip: 'IP',
    metodoHttp: 'HTTP Method',
    dataHora: 'Date/Time',
    endpoint: 'Endpoint',
    detalhes: 'Details',
    valoresAntigos: 'Old Values',
    valoresNovos: 'New Values',
    notFound: 'No audit records found.',
    todasAcoes: 'All actions',
    dataInicio: 'Start Date',
    dataFim: 'End Date',
  },

  comissao: {
    title: 'Commissions',
    calcular: 'Calculate',
    vendedorId: 'Seller ID (optional)',
    dataInicio: 'Start Date',
    dataFim: 'End Date',
    totalVendido: 'Total Sold',
    totalComissoes: 'Total Commissions',
    qtdVendedores: 'Seller Count',
    vendedor: 'Seller',
    qtdVendas: 'Sales Count',
    ticketMedio: 'Average Ticket',
    percentComissao: '% Commission',
    valorComissao: 'Commission Value',
    ranking: 'Seller Ranking',
    vendas: 'sales',
    notFound: 'No commissions found for the period.',
  },

  dashboard: {
    title: 'Dashboard',
    meuDia: 'My Day',
    visaoGerencial: 'Management View',
    controleEstoque: 'Inventory Control',
    administracao: 'System Administration',
    indicadores: 'Real-time Indicators',
    statusCaixa: 'Register Status',
    vendasHoje: 'Sales Today',
    faturamentoHoje: 'Revenue Today',
    saldoCaixa: 'Register Balance',
    vendasMes: 'Monthly Sales',
    faturamentoMes: 'Monthly Revenue',
    ticketMedio: 'Average Ticket',
    canceladasMes: 'Monthly Cancellations',
    produtosEstoque: 'Products in Stock',
    abaixoMinimo: 'Below Minimum',
    estoqueZerado: 'Zero Stock',
    usuarios: 'Users',
    logsAuditoria: 'Audit Logs',
    errosRegistrados: 'Registered Errors',
    configuracoes: 'Settings',
    parcelasVencidas: 'Overdue Installments',
    entregasPendentes: 'Pending Deliveries',
    vendasPorFormaPagamento: 'Sales by Payment Method (Month)',
    acessoRapido: 'Quick Access',
    irParaCaixa: 'Go to Register',
    ultimasVendas: 'Latest Sales',
    estoqueCritico: 'Critical Stock',
    produtosEstoqueCritico: 'Products with Critical Stock',
    ultimasAtividades: 'Latest Activities',
    atividadePorTipo: 'Activity by Type',
    vendasPorMes: 'Sales by Month',
    carregando: 'Loading dashboard...',
    nenhumaVendaHoje: 'No sales today',
    semDadosVendas: 'No sales data',
    semDadosAuditoria: 'No audit data',
    nenhumaAtividade: 'No registered activity',
    nenhumProdutoAbaixo: 'No products below minimum',
  },

  greeting: {
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
  },

  theme: {
    light: 'Light mode',
    dark: 'Dark mode',
  },

  permissao: {
    title: 'Functional Permissions',
    salvarPermissoes: 'Save Permissions',
    saved: 'Permissions saved successfully!',
    saveError: 'Error saving permissions',
    adminAll: 'Administrator has all permissions',
    marcarTodas: 'Select All',
    desmarcarTodas: 'Deselect All',
    permissoesSelecionadas: 'permission(s) selected',
    catVendas: 'Sales',
    catCaixa: 'Cash Register',
    catEstoque: 'Inventory',
    catProdutos: 'Products',
    catFinanceiro: 'Financial',
    catClientes: 'Customers',
    catRelatorios: 'Reports',
    catTrocas: 'Returns & Exchanges',
    catDashboard: 'Dashboard (KPIs)',
    catAdmin: 'Administration',
  },

  banhoTosa: {
    title: 'Grooming',
    new: 'New Appointment',
    edit: 'Edit Appointment',
    details: 'Appointment Details',
    nomeAnimal: 'Pet Name',
    raca: 'Breed',
    porte: 'Size',
    servico: 'Service',
    observacoes: 'Notes',
    valor: 'Price',
    dataAgendamento: 'Appointment Date',
    clienteNome: 'Customer',
    created: 'Appointment created successfully!',
    updated: 'Appointment updated successfully!',
    deleted: 'Appointment deleted successfully!',
    notFound: 'No grooming appointments found.',
    todosServicos: 'All Services',
    banho: 'Bath',
    tosa: 'Grooming',
    banhoTosa: 'Bath + Grooming',
    clienteAgendamento: 'Customer and Appointment',
  },

  racoes: {
    title: 'Pet Food & Accessories',
    new: 'New Pet Product',
    edit: 'Edit Pet Product',
    details: 'Pet Product Details',
    nome: 'Name',
    marca: 'Brand',
    tipo: 'Type',
    animal: 'Animal',
    peso: 'Weight',
    preco: 'Price',
    allTipos: 'All Types',
    allAnimais: 'All Animals',
    racao: 'Pet Food',
    acessorio: 'Accessory',
    brinquedo: 'Toy',
    higiene: 'Hygiene',
    cao: 'Dog',
    gato: 'Cat',
    ave: 'Bird',
    peixe: 'Fish',
    outro: 'Other',
    created: 'Product created successfully!',
    updated: 'Product updated successfully!',
    deleted: 'Product deleted successfully!',
    notFound: 'No pet products found.',
  },

  cardapio: {
    title: 'Menu',
    new: 'New Item',
    edit: 'Edit Item',
    details: 'Item Details',
    nome: 'Name',
    descricao: 'Description',
    categoria: 'Category',
    preco: 'Price',
    disponivel: 'Available',
    tempoPreparo: 'Prep Time',
    foto: 'Photo',
    created: 'Item created successfully!',
    updated: 'Item updated successfully!',
    deleted: 'Item deleted successfully!',
    notFound: 'No menu items found.',
    todasCategorias: 'All Categories',
    disponiveis: 'Available',
    indisponiveis: 'Unavailable',
    entrada: 'Appetizer',
    pratoPrincipal: 'Main Course',
    sobremesa: 'Dessert',
    bebida: 'Beverage',
    petisco: 'Snack',
  },

  mesas: {
    title: 'Table Management',
    new: 'New Table',
    edit: 'Edit Table',
    details: 'Table Details',
    numero: 'Number',
    capacidade: 'Capacity',
    localizacao: 'Location',
    observacoes: 'Notes',
    interna: 'Indoor',
    externa: 'Outdoor',
    varanda: 'Patio',
    allLocalizacoes: 'All Locations',
    allStatus: 'All Status',
    qtdPessoas: 'No. of people',
    pessoas: 'people',
    created: 'Table created successfully!',
    updated: 'Table updated successfully!',
    deleted: 'Table deleted successfully!',
    notFound: 'No tables found.',
  },

  prontuarios: {
    title: 'Veterinary Records',
    new: 'New Record',
    edit: 'Edit Record',
    details: 'Record Details',
    nomeAnimal: 'Pet Name',
    raca: 'Breed',
    especie: 'Species',
    peso: 'Weight',
    idade: 'Age',
    nomeProprietario: 'Owner',
    telefone: 'Phone',
    historicoVacinas: 'Vaccination History',
    alergias: 'Allergies',
    observacoes: 'Notes',
    dataUltimaConsulta: 'Last Visit Date',
    created: 'Record created successfully!',
    updated: 'Record updated successfully!',
    deleted: 'Record deleted successfully!',
    notFound: 'No veterinary records found.',
    especieExemplo: 'e.g. Canine, Feline',
  },

  consultas: {
    title: 'Veterinary Consultations',
    new: 'New Consultation',
    edit: 'Edit Consultation',
    details: 'Consultation Details',
    nomeAnimal: 'Pet',
    proprietario: 'Owner',
    veterinario: 'Veterinarian',
    dataConsulta: 'Date',
    motivo: 'Reason',
    diagnostico: 'Diagnosis',
    prescricao: 'Prescription',
    retorno: 'Follow-up',
    valor: 'Price',
    created: 'Consultation created successfully!',
    updated: 'Consultation updated successfully!',
    deleted: 'Consultation deleted successfully!',
    notFound: 'No consultations found.',
  },

  agendamentos: {
    title: 'Appointments',
    new: 'New Appointment',
    edit: 'Edit Appointment',
    details: 'Appointment Details',
    cliente: 'Customer',
    servico: 'Service',
    profissional: 'Professional',
    dataHora: 'Date/Time',
    duracao: 'Duration',
    observacoes: 'Notes',
    valor: 'Price',
    created: 'Appointment created successfully!',
    updated: 'Appointment updated successfully!',
    deleted: 'Appointment deleted successfully!',
    notFound: 'No appointments found.',
  },

  agendamento: {
    entityName: 'Appointment',
    cliente: 'Customer',
    buscarCliente: 'Search customer...',
    profissional: 'Professional',
    servico: 'Service',
    horario: 'Time',
    terminoEstimado: 'Estimated End',
    valorCobrado: 'Charged Amount (R$)',
    observacao: 'Notes',
  },

  ordensServico: {
    title: 'Service Orders',
    new: 'New Service Order',
    edit: 'Edit Service Order',
    details: 'Service Order Details',
    numero: 'Number',
    cliente: 'Customer',
    descricaoServico: 'Service Description',
    equipamento: 'Equipment',
    marcaModelo: 'Brand/Model',
    defeito: 'Defect',
    solucao: 'Solution',
    pecasUsadas: 'Parts Used',
    valorMaoDeObra: 'Labor Cost',
    valorPecas: 'Parts Cost',
    valorTotal: 'Total',
    dataEntrada: 'Entry Date',
    dataSaida: 'Completion Date',
    created: 'Service order created successfully!',
    updated: 'Service order updated successfully!',
    deleted: 'Service order deleted successfully!',
    notFound: 'No service orders found.',
    numeroOS: 'Order Number',
    defeitoRelatado: 'Reported Defect',
    previsaoSaida: 'Expected Completion',
    valoresDatas: 'Values and Dates',
    valores: 'Values',
  },

  fidelidade: {
    title: 'Loyalty Program',
    programa: 'Program Settings',
    ranking: 'Points Ranking',
    historico: 'Points History',
    pontos: 'Points',
    resgatar: 'Redeem',
    cliente: 'Customer',
    saldo: 'Balance',
    notFound: 'No loyalty data found.',
    resgatarPontos: 'Redeem Points',
    buscarClienteNome: 'Search customer by name...',
    pontosDisponiveis: 'Available Points',
    pontosParaResgatar: 'Points to Redeem',
    quantidadePontos: 'Number of points',
    minimoResgate: 'Minimum for redemption',
    motivoResgate: 'Reason for redemption (optional)',
    confirmarResgate: 'Confirm Redemption',
    valorEmReais: 'Value in R$',
    erroCarregarPontos: 'Error loading customer points',
    pontosResgatadosSucesso: '{pontos} points redeemed successfully!',
    erroResgatarPontos: 'Error redeeming points',
    nomePrograma: 'Program Name',
    pontosPerReal: 'Points per R$ spent',
    valorPontosResgate: 'Value per point in redemption (R$)',
    pontosAcumulados: 'Accumulated Points',
    pontosResgatados: 'Redeemed Points',
    ultimaMovimentacao: 'Last Movement',
    tipo: 'Type',
    programaAtivo: 'Program Active',
    programaInativo: 'Program Inactive',
    salvarConfiguracao: 'Save Settings',
  },

  funcionario: {
    title: 'Employee Management',
    new: 'New Employee',
    edit: 'Edit Employee',
    details: 'Employee Details',
    nome: 'Name',
    cargo: 'Position',
    telefone: 'Phone',
    email: 'Email',
    dataAdmissao: 'Hire Date',
    comissao: 'Commission %',
    created: 'Employee created successfully!',
    updated: 'Employee updated successfully!',
    deleted: 'Employee deleted successfully!',
    matricula: 'Employee ID',
    departamento: 'Department',
    cpf: 'CPF',
    endereco: 'Address',
    observacao: 'Note',
    observacoes: 'Notes',
    usuarioVinculado: 'Linked User',
    dadosProfissionais: 'Professional Data',
    dadosPessoais: 'Personal Data (LGPD)',
    vinculo: 'Link',
    nomeCompleto: 'Full name',
    codigoInterno: 'Internal code',
    enderecoCompleto: 'Full address',
    selecioneCargo: 'Select a position',
    selecioneDepartamento: 'Select a department',
    usuarioOpcional: 'User (optional)',
    selecioneUsuario: 'Select user...',
    allCargos: 'All Positions',
    allDepartamentos: 'All Departments',
    ativos: 'Active',
    inativos: 'Inactive',
    semVinculo: 'No link',
    deactivate: 'Deactivate',
    dataDemissao: 'Termination Date',
    notFound: 'No employees found.',
  },

  servico: {
    title: 'Service Management',
    new: 'New Service',
    edit: 'Edit Service',
    details: 'Service Details',
    nome: 'Name',
    descricao: 'Description',
    preco: 'Price',
    duracao: 'Duration',
    duracaoMinutos: 'Duration (minutes)',
    categoria: 'Category',
    ativo: 'Active',
    selectCategoria: 'Select category',
    allCategorias: 'All Categories',
    created: 'Service created successfully!',
    updated: 'Service updated successfully!',
    deleted: 'Service deleted successfully!',
    notFound: 'No services found.',
  },

  profissional: {
    title: 'Professional Management',
    new: 'New Professional',
    edit: 'Edit Professional',
    details: 'Professional Details',
    nome: 'Name',
    especialidade: 'Specialty',
    telefone: 'Phone',
    email: 'Email',
    comissao: 'Commission (%)',
    ativo: 'Active',
    selectEspecialidade: 'Select specialty',
    created: 'Professional created successfully!',
    updated: 'Professional updated successfully!',
    deleted: 'Professional deleted successfully!',
    notFound: 'No professionals found.',
  },

  receituario: {
    title: 'Prescriptions',
    new: 'New Prescription',
    edit: 'Edit Prescription',
    cliente: 'Customer',
    medico: 'Doctor',
    crm: 'CRM',
    dataReceita: 'Prescription Date',
    dataValidade: 'Expiry Date',
    dadosGerais: 'General Data',
    selecioneCliente: 'Select customer...',
    nomeMedico: 'Doctor name',
    olhoDireito: 'Right Eye (OD)',
    olhoEsquerdo: 'Left Eye (OE)',
    esferico: 'Spherical',
    cilindrico: 'Cylindrical',
    eixo: 'Axis',
    dnp: 'DNP',
    adicao: 'Addition',
    lenteArmacao: 'Lens and Frame',
    tipoLente: 'Lens Type',
    materialLente: 'Lens Material',
    material: 'Material',
    armacao: 'Frame',
    descricaoArmacao: 'Frame description',
    observacoes: 'Notes',
  },

  exameOptometria: {
    title: 'Optometry Exams',
    new: 'New Optometry Exam',
    edit: 'Edit Optometry Exam',
    cliente: 'Customer',
    optometrista: 'Optometrist',
    nomeOptometrista: 'Optometrist name',
    registro: 'Registration',
    registroProfissional: 'Professional registration',
    dataExame: 'Exam Date',
    dadosExame: 'Exam Data',
    refracaoOD: 'Refraction - Right Eye (OD)',
    refracaoOE: 'Refraction - Left Eye (OE)',
    acuidadeVisual: 'Visual Acuity',
    odSemCorrecao: 'OD w/o Correction',
    odComCorrecao: 'OD w/ Correction',
    oeSemCorrecao: 'OE w/o Correction',
    oeComCorrecao: 'OE w/ Correction',
    pressaoIntraocular: 'Intraocular Pressure',
    pressaoOD: 'Pressure OD (mmHg)',
    pressaoOE: 'Pressure OE (mmHg)',
    informacoesAdicionais: 'Additional Information',
    observacoes: 'Notes',
    encaminhamento: 'Referral',
  },

  pet: {
    title: 'Pets',
    new: 'New Pet',
    edit: 'Edit Pet',
    cliente: 'Customer',
    nomeAnimal: 'Pet Name',
    dadosAnimal: 'Pet Data',
    especie: 'Species',
    raca: 'Breed',
    cor: 'Color',
    caracteristicas: 'Characteristics',
    porte: 'Size',
    pesoKg: 'Weight (kg)',
    idade: 'Age',
    idadeExemplo: 'e.g. 3 years',
    sexo: 'Sex',
    macho: 'Male',
    femea: 'Female',
    pequeno: 'Small',
    medio: 'Medium',
    grande: 'Large',
    castrado: 'Neutered',
    saude: 'Health',
    alergias: 'Allergies',
    alergiasConhecidas: 'Known allergies',
    observacoes: 'Notes',
    observacoesGerais: 'General notes',
  },

  segmentoDominio: {
    title: 'Segments',
    new: 'New Segment',
    edit: 'Edit Segment',
    icone: 'Icon',
    ordem: 'Order',
    informacoes: 'Segment Information',
    nomePlaceholder: 'Segment name',
    descricaoPlaceholder: 'Segment description',
    iconePlaceholder: 'E.g.: fas fa-store',
    nomeObrigatorio: 'Name is required',
    created: 'Segment created successfully!',
    updated: 'Segment updated successfully!',
    deleted: 'Segment deleted successfully!',
    createError: 'Error creating segment',
    updateError: 'Error updating segment',
    deleteError: 'Error deleting segment',
  },

  planoDominio: {
    title: 'Plans',
    new: 'New Plan',
    edit: 'Edit Plan',
    preco: 'Price',
    ordem: 'Order',
    informacoes: 'Plan Information',
    nomePlaceholder: 'Plan name',
    descricaoPlaceholder: 'Plan description',
    nomeObrigatorio: 'Name is required',
    created: 'Plan created successfully!',
    updated: 'Plan updated successfully!',
    deleted: 'Plan deleted successfully!',
    createError: 'Error creating plan',
    updateError: 'Error updating plan',
    deleteError: 'Error deleting plan',
  },
  nfce: {
    title: 'NFC-e',
    numero: 'Number',
    serie: 'Series',
    venda: 'Sale',
    valorTotal: 'Total Value',
    dataEmissao: 'Issue Date',
    dataAutorizacao: 'Authorization Date',
    chaveAcesso: 'Access Key',
    protocolo: 'Protocol',
    qrCode: 'QR Code',
    statusAutorizada: 'Authorized',
    statusRejeitada: 'Rejected',
    statusPendente: 'Pending',
    statusLocal: 'Local',
    statusCancelada: 'Cancelled',
    emitir: 'Issue NFC-e',
    emitirTitle: 'Issue NFC-e',
    selecionarVenda: 'Select Sale',
    cancelar: 'Cancel NFC-e',
    cancelarTitle: 'Cancel NFC-e',
    cancelarAviso: 'Warning: Cancelling an NFC-e is irreversible. Provide the justification below.',
    justificativa: 'Justification',
    justificativaPlaceholder: 'Enter the cancellation reason...',
    minCaracteres: 'minimum 15 characters',
    confirmarCancelamento: 'Confirm Cancellation',
    danfe: 'DANFE',
    dataInicio: 'Start Date',
    dataFim: 'End Date',
    emitidaSucesso: 'NFC-e issued successfully!',
    canceladaSucesso: 'NFC-e cancelled successfully!',
    erroEmitir: 'Error issuing NFC-e',
    erroCancelar: 'Error cancelling NFC-e',
    erroDanfe: 'Error downloading DANFE',
  },

  configuracaoFiscal: {
    title: 'Tax Configuration',
    dadosFiscais: 'Tax Data',
    dadosNfce: 'NFC-e Data',
    opcoes: 'Options',
    uf: 'State',
    ambiente: 'Environment',
    homologacao: 'Sandbox',
    producao: 'Production',
    modalidade: 'Mode',
    regimeTributario: 'Tax Regime',
    simplesNacional: 'Simples Nacional',
    lucroPresumido: 'Lucro Presumido',
    lucroReal: 'Lucro Real',
    serieNfce: 'NFC-e Series',
    ultimoNumeroNfce: 'Last NFC-e Number',
    inscricaoEstadual: 'State Registration',
    csc: 'CSC (Taxpayer Security Code)',
    cscId: 'CSC ID',
    emissaoAutomatica: 'Automatic Issuance',
    camposObrigatorios: 'Fill in all required fields',
    cscObrigatorio: 'CSC and CSC ID are required for SEFAZ mode',
    salvoSucesso: 'Tax configuration saved successfully!',
    erroSalvar: 'Error saving tax configuration',
  },

  certificado: {
    title: 'Digital Certificates',
    cnpj: 'CNPJ',
    validade: 'Expiration',
    tipo: 'Type',
    arquivo: 'File',
    upload: 'Upload Certificate',
    uploadTitle: 'Upload Digital Certificate',
    arquivoPfx: 'PFX/P12 File',
    senha: 'Certificate Password',
    senhaPlaceholder: 'Enter the certificate password',
    enviar: 'Upload',
    desativar: 'Deactivate',
    nenhumEncontrado: 'No certificates found.',
    uploadSucesso: 'Certificate uploaded successfully!',
    desativadoSucesso: 'Certificate deactivated successfully!',
    erroUpload: 'Error uploading certificate',
    erroDesativar: 'Error deactivating certificate',
  },

  lgpd: {
    title: 'Privacy and Data',
    politica: 'Privacy Policy',
    exportar: 'Export My Data',
    excluir: 'Delete My Data',
    consentimento: 'Consent',
    consentimentoDados: 'Consent for data processing',
    consentimentoMarketing: 'Consent for marketing communications',
    salvarConsentimento: 'Save Consent',
    exportando: 'Exporting...',
    solicitarExclusao: 'Request Deletion',
    baixarJson: 'Download JSON',
  },

  pix: {
    pagarComPix: 'Pay with PIX',
    valor: 'Amount',
    beneficiario: 'Beneficiary',
    chave: 'PIX Key',
    copiaECola: 'PIX Copy and Paste',
    copiar: 'Copy',
    copiado: 'Copied!',
    instrucao: 'Open your bank app, scan the QR Code or paste the code above.',
    erroGerar: 'Could not generate PIX QR Code.',
    configureChave: 'Configure the PIX key in Administration > PIX Config.',
    configuracao: 'PIX Configuration',
    chavePix: 'PIX Key',
    tipoChave: 'Key Type',
    nomeBeneficiario: 'Beneficiary Name',
    cidadeBeneficiario: 'Beneficiary City',
    testar: 'Test QR Code',
    salvar: 'Save Configuration',
    tiposCpf: 'CPF',
    tiposCnpj: 'CNPJ',
    tiposEmail: 'E-mail',
    tiposTelefone: 'Phone',
    tiposAleatoria: 'Random Key',
  },
  multiLoja: {
    title: 'Multi-Store Dashboard',
    vendasHoje: 'Sales Today',
    faturamentoMes: 'Monthly Revenue',
    estoqueCritico: 'Critical Stock',
    parcelasVencidas: 'Overdue Installments',
    comparativo: 'Store Comparison',
    loja: 'Store',
    segmento: 'Segment',
    qtdVendas: 'Sales Count',
    parcelas: 'Installments',
    entregas: 'Deliveries',
    verDetalhes: 'View Details',
    todasAsLojas: 'All Stores',
  },
}
